import { BodyLong, Heading, Link, VerticalSpace, HorizontalSpace } from '@elhub/ds-components'

import React from 'react'
import ReactJson from 'react-json-view'
import { Link as NavLink } from 'react-router-dom'

const json = {
  meta: {
    created: '2024-04-22T22:33:21+02:00'
  },
  links: {
    self: 'https://api.elhub.no/data-export/v0/energy-data'
  },
  data: [
    {
      type: 'job',
      id: '3f3e62bb-ed02-45fa-a951-a979491524a3',
      relationships: {
        files: {
          data: [
            {
              type: 'file',
              id: 'e128b01f-7767-4cc5-9801-c5f28220521a'
            },
            {
              type: 'file',
              id: 'f6426100-2bd8-458f-88dc-6fd07f29b67c'
            }
          ]
        }
      },
      attributes: {
        status: 'Completed',
        type: 'portfolio'
      }
    }
  ],
  included: [
    {
      type: 'file',
      id: 'e128b01f-7767-4cc5-9801-c5f28220521a',
      attributes: {
        filename: 'part-00000-945b3263-9511-4287-9f57-95b387a0d506-c000.csv.gz',
        location: '42091270-a5aa-4503-b1c8-98507ceecfba/'
      }
    },
    {
      type: 'file',
      id: 'f6426100-2bd8-458f-88dc-6fd07f29b67c',
      attributes: {
        filename: 'part-00001-945b3263-9511-4287-9f57-95b387a0d506-c000.csv.gz',
        location: '42091270-a5aa-4503-b1c8-98507ceecfba/'
      }
    }
  ]
}

const EnergyDataJob = () => {
  return (
    <>
      <Heading>Energy Data Export</Heading>
      <BodyLong size='small'>
        Retrieve a list of available data export job and file IDs for your GLN.
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        This endpoint retrieves a list of data export job IDs and the corresponding file IDs for the specified
        GLN in the request. Access to this endpoint is protected by Maskinporten Authentication and is only
        available to users assigned the relevant scope by Elhub. Read more{' '}
        <Link variant='primary' href='https://api.elhub.no/maskinporten/create-client'>
          {' '}
          here{' '}
        </Link>
        <HorizontalSpace size='0.2' />
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        To access the endpoint, use a Maskinporten token as a Bearer token and include the following header:
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>X-Elhub-GLN : your-gln-value</BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        The fileId returned in the response should be used in
        <HorizontalSpace size='0.2' />
        <Link as={NavLink} to='https://api.elhub.no/api/energy-data#/File/energy_data_file_id'>
          Energy data file endpoint
        </Link>
        <HorizontalSpace size='0.2' />
        to download the files
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <b>File retention :</b>
        Files are available for 7 days after they are generated. Once they expire, the corresponding job will
        no longer be included in the response.
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>
        <b>Example request :</b>
        <Link as={NavLink} to='https://api.elhub.no/data-export/v0/energy-data'>
          https://api.elhub.no/data-export/v0/energy-data
        </Link>
      </BodyLong>
      <VerticalSpace />
      <BodyLong size='small'>Sample response:</BodyLong>
      <ReactJson src={json} collapsed name={false} sortKeys />
      <VerticalSpace />
    </>
  )
}
export default EnergyDataJob
